import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// Component
import { EditAlertAuthComponent } from './edit-alert-auth/edit-alert-auth.component';
import { NotifierOptionsComponent } from './notifier-options/notifier-options.component';
import { NotifierModule, NotifierOptions } from 'angular-notifier';

/**
 * Custom angular notifier options
 */
 const customNotifierOptions: NotifierOptions = {
  position: {
		horizontal: {
			position: 'right',
			distance: 12
		},
		vertical: {
			position: 'bottom',
			distance: 12,
			gap: 10
		}
	},
  theme: 'material',
  behaviour: {
    autoHide: 5000,
    onClick: 'hide',
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 4
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 300,
      easing: 'ease'
    },
    hide: {
      preset: 'fade',
      speed: 300,
      easing: 'ease',
      offset: 50
    },
    shift: {
      speed: 300,
      easing: 'ease'
    },
    overlap: 150
  }
};

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NotifierModule.withConfig(customNotifierOptions)
  ],
  declarations: [
    EditAlertAuthComponent,
    NotifierOptionsComponent
  ],
  exports: [
    EditAlertAuthComponent,
    NotifierOptionsComponent
  ]
})
export class PartialsModule { }
